import { PreBidEventAuction, PreBidEventBidWon, PreBidEventUserIdAsEids } from '@repo/shared-types';

import { setTargeting } from './setTargeting';

const isLiveIntentEid = (eid: PreBidEventUserIdAsEids): boolean =>
  eid.source === 'liveintent.com' ||
  (eid.uids?.some(uid => uid.ext?.provider === 'liveintent.com') ?? false);

export const onAuction = (auction: PreBidEventAuction): void => {
  const enriched =
    auction.adUnits?.some(adUnit =>
      adUnit.bids?.some(bid => bid.userIdAsEids?.some(isLiveIntentEid)),
    ) ?? false;

  setTargeting(enriched);
};

export const onBidWon = (bid: PreBidEventBidWon): void => {
  if (bid.dealId) {
    const { dealId } = bid;
    googletag.cmd.push(function () {
      googletag.pubads().setTargeting('dealID', dealId);
    });
  }
};
